import React from 'react';

import MapCard from '../dashboard/MapCard';

export default function ViewContent({ responseHeatmap, type }) {
  return (
    <div className="view-content view-dashboard">
      <MapCard responseHeatmap={responseHeatmap} type={type} />
    </div>
  );
}
